import { ProvidersProps } from "./types";
import ActionsProvider from "./Actions";
import AuthProvider from "./Auth";
import FrigadeProviderWrapper from "./Frigade";
import QueriesProvider from "./Queries";
import RouterProvider from "./Router";
import { SidebarProvider } from "./Sidebar";
import StiggProviderWrapper from "./Stigg";
import ThemeProvider from "./Theme";
import { WebSocketProvider } from "./Websocket";


export default function ProvidersA({ children }: ProvidersProps) {
  return (
    <QueriesProvider>
      <AuthProvider>
        <RouterProvider>
          <ThemeProvider>
            <SidebarProvider>
              <StiggProviderWrapper>
                <FrigadeProviderWrapper>
                  <WebSocketProvider>
                    <ActionsProvider>{children}</ActionsProvider>
                  </WebSocketProvider>
                </FrigadeProviderWrapper>
              </StiggProviderWrapper>
            </SidebarProvider>
          </ThemeProvider>
        </RouterProvider>
      </AuthProvider>
    </QueriesProvider>
  );
}